import { createSvgIcon } from '../../createSvgIcon';

export const PhoneIcon = createSvgIcon(
  <path
    d="M0.75 2.52778C0.75 2.05628 0.937301 1.6041 1.2707 1.2707C1.6041 0.937301 2.05628 0.75 2.52778 0.75H5.44333C5.62982 0.750142 5.81153 0.80893 5.96276 0.918044C6.11399 1.02716 6.22707 1.18107 6.286 1.358L7.61756 5.35178C7.68502 5.55475 7.67704 5.77524 7.59508 5.9728C7.51312 6.17036 7.36267 6.33174 7.17133 6.42733L5.16511 7.43178C6.14859 9.60851 7.89221 11.3518 10.0691 12.3349L11.0718 10.3287C11.1674 10.1373 11.3288 9.98688 11.5263 9.90492C11.7239 9.82296 11.9444 9.81498 12.1473 9.88244L16.142 11.214C16.3191 11.273 16.4731 11.3862 16.5822 11.5376C16.6913 11.689 16.75 11.8709 16.75 12.0576V14.9722C16.75 15.4437 16.5627 15.8959 16.2293 16.2293C15.8959 16.5627 15.4437 16.75 14.9722 16.75H14.0833C6.71978 16.75 0.75 10.7802 0.75 3.41667V2.52778Z"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  { displayName: 'PhoneIcon', viewBox: '0 0 18 18' }
);
